import type { TourDefinition } from '../training/tours';

/**
 * Тур «Налаштування Google Workspace». Ідентифікатор для реєстрації: 'connectors-google'.
 * Цілі — атрибути data-tour на сторінці /connectors/google (features/connectors/google/*).
 */
export const CONNECTORS_GOOGLE_TOUR_ID = 'connectors-google';

export const CONNECTORS_GOOGLE_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Налаштування Google Workspace',
  summary: 'Ключ сервісного облікового запису, функції й обліковий запис викладача Google Класу, перевірка з’єднання, делегування на весь домен і реєстр областей доступу.',
  missingHint: 'Відкрийте «Інтеграції» › «Google Workspace» › «Налаштування» — підказки прив’яжуться до розділів сторінки.',
  steps: [
    {
      id: 'key',
      target: 'connectors-google-key',
      title: 'Ключ сервісного облікового запису',
      body: 'Завантажте JSON-ключ із Google Cloud. До збереження ЄРС показує лише адресу облікового запису, проєкт і кінець ідентифікатора ключа; після збереження ключ зашифровано, і його ніхто більше не побачить — лише «налаштовано …» і кнопку заміни.',
      placement: 'bottom',
    },
    {
      id: 'features',
      target: 'connectors-google-features',
      title: 'Функції',
      body: 'Вмикайте лише те, чим фірма користується: каталог працівників, календарі, Drive, пошту ЄРС, Google Клас. Позначка «Потребує делегування» показує, яким функціям потрібен доступ від імені працівника.',
    },
    {
      id: 'teacher',
      target: 'connectors-google-teacher',
      title: 'Google Клас і обліковий запис викладача',
      body: 'Для імпорту курсів у Базу навчання вкажіть власника курсів у домені: ЄРС читає курси від його імені й лише для читання. Без цього облікового запису імпорт не працюватиме.',
    },
    {
      id: 'test',
      target: 'connectors-google-test',
      title: 'Перевірка з’єднання',
      body: 'Після збереження перевірте з’єднання: для кожної увімкненої функції видно «працює» чи «помилка» з поясненням Google. Помилку доступу зазвичай виправляє погодження областей чи делегування.',
    },
    {
      id: 'delegation',
      target: 'connectors-google-delegation',
      title: 'Делегування на весь домен',
      body: 'Скопіюйте ідентифікатор клієнта й перелік областей через кому та додайте їх у Консолі адміністратора Google («Безпека» › «Доступ і керування даними» › «Елементи керування API»). Google радить не делегувати без потреби.',
    },
    {
      id: 'scopes',
      target: 'connectors-google-scopes',
      title: 'Реєстр областей доступу',
      body: 'ЄРС запитує в Google лише погоджені області. Погодження фіксує, хто й коли дозволив доступ, і дату перегляду — щонайменше раз на 90 днів. Непотрібну область відкликайте.',
    },
  ],
};
